<div>
  <span>{{sliderObject.formName}}</span>
  <form [formGroup]="form">
    <formly-form [model]="model" [fields]="fields" [options]="options" [form]="form"></formly-form>
    <button *ngIf="showSubmit" type="submit" class="btn btn-outline-dark m-2">{{submitText}}</button>
  </form>
</div>